module.exports = __webpack_public_path__ + "pc/img/rec_04.9cabee5a.svg";